import React, { useCallback, useEffect, useState } from 'react';
import View from './View';
import DeliveryOrder, { PostDeliveryOrderBody } from 'src/interfaces/api/DeliveryOrder';
import useDeliveryOrder from 'src/hooks/api/useDeliveryOrder';

const ViewContainer = ({ match, history }) => {
  const [deliveryOrder, setDeliveryOrder] = useState<DeliveryOrder>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const { get, create, update } = useDeliveryOrder();

  const { id } = match.params;

  useEffect(() => {
    if (id) {
      setError(undefined);
      setLoading(true);
      get(id)
        .then((order) => {
          setLoading(false);
          order.articles = order.articles.map((article) => ({ ...article, enabled: true }));
          setDeliveryOrder(order);
        })
        .catch((error) => {
          setLoading(false);
          setError(error.message);
        });
    }
  }, [id]);

  const handleSaveDeliveryOrder = useCallback(
    async (order: PostDeliveryOrderBody): Promise<DeliveryOrder> => {
      if (deliveryOrder?.id) {
        return await update(deliveryOrder.id, order);
      } else {
        return await create(order);
      }
    },
    [deliveryOrder]
  );

  const handleGoBack = () => {
    history.push('/dashboard/delivery-orders');
  };

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return <View goBack={handleGoBack} onSaveDeliveryOrder={handleSaveDeliveryOrder} deliveryOrder={deliveryOrder} />;
};

export default ViewContainer;
